export const GoogleAppScopeList = [
  "profile",
  "email",
  "openid",
  "https://www.googleapis.com/auth/analytics.edit",
] as const;
export type GoogleAppScopeType = (typeof GoogleAppScopeList)[number];

export const IntelligemsAppScopeList = [
  "read_cart_transforms",
  "write_cart_transforms",
  "read_products",
  "write_products",
  "read_inventory",
  "write_inventory",
  "read_checkouts",
  "read_analytics",
  "read_themes",
  "write_themes",
  "read_orders",
  "read_discounts",
  "write_discounts",
  "write_script_tags",
  "read_shipping",
  "write_shipping",
  "read_customers",
  "write_pixels",
  "read_pixels",
  "read_customer_events",
  "read_content",
] as const;

const IntelligemsPlanList = [
  "2K",
  "5K",
  "10K",
  "15K",
  "20K",
  "35K",
  "50K",
  "75K",
  "100K",
  "150K",
  "200K",
  "300K",
];

export type IntelligemsPlanType = (typeof IntelligemsPlanList)[number];

export type IntelligemsAppScopeType = (typeof IntelligemsAppScopeList)[number];

export const IntelligemsRoleList = ["intelligems", "member"] as const;
export type IntelligemsRoles = (typeof IntelligemsRoleList)[number];

export const IntelligemsAuthScopesList = [
  "no_auth",
  "internal",
  "intelligems",
  "member",
] as const;

export type IntelligemsAuthScopes = (typeof IntelligemsAuthScopesList)[number];

export const IntelligemsSlackChannelList = [
  "#dev-app-log",
  "#app-log",
  "#dev-api-messages",
  "#in-the-money",
  "#prod-api-messages",
  "#support-shift",
  "#sales_alerts",
  "#dev-config-deploy",
  "#prod-config-deploy",
  "#christian-dev-channel",
  "#monitoring-alerts-important",
  "#dev-customer-api-alerts",
  "#prod-customer-api-alerts",
] as const;

export type IntelligemsSlackChannel =
  (typeof IntelligemsSlackChannelList)[number];

export const IntelligemsWebUiScopeList = [
  "view_analytics",
  "view_shipping_experiment",
  "create_shipping_experiment",
  "start_shipping_experiment",
  "edit_shipping_experiment",
  "view_price_experiment",
  "create_price_experiment",
  "start_price_experiment",
  "edit_price_experiment",
  "view_discount_experiment",
  "create_discount_experiment",
  "start_discount_experiment",
  "edit_discount_experiment",
  "edit_advanced_settings",
  "view_volume_discount",
  "view_new_dashboard",
  "view_content_experiment",
  "create_content_experiment",
  "start_content_experiment",
  "edit_content_experiment",
  "create_combo_price_shipping_test",
  "price_test_subscription_products",
  "price_test_manual_csv_upload",
  "audience_targeting_basic",
  "audience_targeting_advanced",
] as const;

export type IntelligemsWebUiScope = (typeof IntelligemsWebUiScopeList)[number];

export type IntelligemsScopes = {
  edit_shipping_experiment?: boolean;
  view_shipping_experiment?: boolean;
  view_volume_discount?: boolean;
  view_new_dashboard?: boolean;
  start_price_experiment?: boolean;
  view_discount_experiment?: boolean;
  audience_targeting_basic?: boolean;
  edit_price_experiment?: boolean;
  view_price_experiment?: boolean;
  edit_discount_experiment?: boolean;
  price_test_manual_csv_upload?: boolean;
  create_combo_price_shipping_test?: boolean;
  view_analytics?: boolean;
  start_shipping_experiment?: boolean;
  price_test_subscription_products?: boolean;
  create_shipping_experiment?: boolean;
  edit_advanced_settings?: boolean;
  audience_targeting_advanced?: boolean;
  start_discount_experiment?: boolean;
  create_price_experiment?: boolean;
  create_discount_experiment?: boolean;
  create_content_experiment?: boolean;
  start_content_experiment?: boolean;
  view_content_experiment?: boolean;
  edit_content_experiment?: boolean;
  test_group_limit?: number;
  concurrent_tests?: number;
  price_test_product_limit?: number;
  shipping_test_flat_rate?: boolean;
  shipping_test_flat_rate_with_threshold?: boolean;
  shipping_test_threshold_only?: boolean;
  shipping_test_tiered_rate?: boolean;
  shipping_test_custom_rate?: boolean;
  shipping_test_rate_limit?: number;
};

export const DemoExperienceIdsList = [
  "05508588-9ee5-46e3-9dcb-ed1d20859f29",
  "167425ab-921f-4c49-a950-e7b5bd316a8c",
  "7b82e56f-049b-4cd3-9e28-cd31ce9f965e",
  "bf493a3e-8fe4-44f6-b180-716dee6fc391",
  "d126e218-7a7b-4262-ab27-02e557522294",
];

export const DemoOrgIdsList = [
  "e8d100f6-a35e-4220-8fa0-b2124ca96c34",
  "1ddcb33e-096a-4343-9ab1-7f3e91c62ac2",
];

export const DemoTablesToSkipList = ["user", "organization", "role"];
